import {ChangeDetectionStrategy, Component, computed, inject, input} from '@angular/core';
import {AppConfigService} from '../../services/app-config.service';

@Component({
  selector: 'app-segment-icon',
  templateUrl: './segment-icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SegmentIconComponent {
  public segment = input<string>(null);
  public imageSize = input<number>(240);
  public isPriority = input<boolean>(false);

  private illustrations = [
    {segment: 'primary care', path: 'primary_care_segment.png'},
    {segment: 'dental care', path: 'dentist_segment.png'},
    {segment: 'manual therapy', path: 'manual_therapy_segment.png'},
    {segment: 'mental health', path: 'mental_health_segment.png'},
    {segment: 'specialist care', path: 'specialist_care_segment.png'},
    {segment: 'aestetics', path: 'beauty_segment.png'},
  ];

  private appConfigService: AppConfigService = inject(AppConfigService);
  public path = computed<string>(() => {
    const path: string = this.illustrations.find((i) => i.segment === this.segment()?.toLowerCase())?.path;
    if (path) {
      return `${this.appConfigService.appConfig.amazonS3Url}assets/illustrations/${path}`;
    }
    return null;
  });
}
